import { useEffect, useState } from 'react';

const KEY = 'lxt-theme';
const DEFAULT_THEME = 'dark';

export const getTheme = () => {
  try { return localStorage.getItem(KEY) || DEFAULT_THEME; } catch { return DEFAULT_THEME; }
};

export const applyTheme = (theme) => {
  const root = document.documentElement;
  root.classList.toggle('dark', theme === 'dark');
  root.dataset.theme = theme;
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute('content', theme === 'dark' ? '#0A0D12' : '#FFF9F1');
  try { localStorage.setItem(KEY, theme); } catch { /* private mode */ }
  window.dispatchEvent(new CustomEvent('lxt-theme-change', { detail: theme }));
};

export const useTheme = () => {
  const [theme, setTheme] = useState(getTheme);
  useEffect(() => {
    const onChange = (e) => setTheme(e.detail);
    window.addEventListener('lxt-theme-change', onChange);
    return () => window.removeEventListener('lxt-theme-change', onChange);
  }, []);
  const toggle = () => applyTheme(theme === 'dark' ? 'light' : 'dark');
  return { theme, toggle, isDark: theme === 'dark' };
};
